import { render, staticRenderFns } from "./Blocker.html?vue&type=template&id=874b9d1e&scoped=true&"
import script from "./Blocker.ts?vue&type=script&lang=ts&"
export * from "./Blocker.ts?vue&type=script&lang=ts&"
import style0 from "./Blocker.scss?vue&type=style&index=0&id=874b9d1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874b9d1e",
  null
  
)

export default component.exports